import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPilotList, setPilotList } from "store/dataReducers/pilotsSlice";
import { PilotApis } from "apis/pilotAPI";
import { useGlobalConfig } from "context/GlobalContext";

export function useHydratePilots() {
  const dispatch = useDispatch();
  const pilotList = useSelector(selectPilotList);
  const { rc } = useGlobalConfig();
  const hasHydrated = useRef(false);

  useEffect(() => {
    async function hydrate() {
      if (!pilotList || pilotList.length === 0) {
        if (!hasHydrated.current) {
          hasHydrated.current = true;
          const resp = await PilotApis.getPilots(rc);
          if (resp.data?.data) {
            dispatch(setPilotList(resp.data.data));
          }
        }
      }
    }
    hydrate();
    // Only run on mount or if rc changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rc]);
} 